import Vue from 'vue'
import Router from 'vue-router'
import { router_loyalty, routes_loyalty_auth, routes_loyalty_user } from "@/views/loyalty/router_loyalty"
import MainLoyalty from "@/views/loyalty/components/core/MainLoyalty.vue"
import { router_reminder_client } from "@/views/reminder/router_reminder"
import FinalReconList from "@/views/admin/FinalRecon-list.vue"

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/cheque',
      component: () => import('@/views/pages/cheque'),
    },
    {
      path: '/paymentsystem',
      component: () => import('@/views/pages/paymentsystem/PaymentSystem.vue')
    },
    {
      path: '/qr',
      component: () => import('@/views/pages/qrpay/QrPay.vue')
    },
    {
      path: '/qrFail',
      component: () => import('@/views/pages/qrpay/QrPayFailure.vue')
    },
    {
      path: '/qrOk',
      component: () => import('@/views/pages/qrpay/QrPaySuccess.vue')
    },
    {
      path: '/qrpayment',
      component: () => import('@/views/pages/QrPayment.vue')
    },
    {
      path: '/qrpaymentFailure',
      component: () => import('@/views/pages/qrpayment/QrPaymentFailure.vue')
    },
    {
      path: '/qrpaymentSuccess',
      component: () => import('@/views/pages/qrpayment/QrPaymentSuccess.vue')
    },
    {
      path: '/paymentsystemfailure',
      component: () => import('@/views/pages/paymentsystem/PaymentSystemFailure.vue')
    },
    {
      path: '/paymentsystemsuccess',
      component: () => import('@/views/pages/paymentsystem/PaymentSystemSuccess.vue')
    },
    {
      path: '/pages',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Login',
          path: 'login',
          component: () => import('@/views/pages/Login'),
        },
        {
          name: 'Confirmation',
          path: 'confirmation',
          component: () => import('@/views/pages/Confirmation'),
        },
        {
          name: 'Recover',
          path: 'Recover',
          component: () => import('@/views/pages/Recover'),
        },
          // ...routes_loyalty_auth, // for loyalty
      ],
    },
    {
      path: '/admin',
      component: () => import('@/views/admin/Index'),
      children: [
        ...router_loyalty, // for loyalty
        ...router_reminder_client, // for reminder
        {
          name: 'Сверка итогов',
          path: 'finalrecon/list',
          component: FinalReconList
        },
        {
          name: 'Сверка итогов - просмотр',
          path: 'finalrecon/view',
          component: () => import('@/views/admin/FinalRecon-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        // Dashboard
        {
          name: 'Dashboard',
          path: 'dashboard',
          component: () => import('@/views/admin/Dashboard'),
        },
        {
          name: 'FRTest',
          path: 'frtest',
          component: () => import('@/views/admin/FRTest'),
        },
        {
          name: 'События',
          path: 'event/list',
          component: () => import('@/views/admin/Event-list'),
        },
        {
          name: 'Список договоров',
          path: 'contract/list',
          component: () => import('@/views/admin/Contract-list'),
        },
        {
          name: 'Список клиентов',
          path: 'client/list',
          component: () => import('@/views/admin/Client-list'),
        },
        {
          name: 'Пользователи',
          path: 'user/list',
          component: () => import('@/views/admin/User-list'),
        },
        {
          name: 'Список таблиц',
          path: 'table/list',
          component: () => import('@/views/admin/Table-list'),
        },
        {
          name: 'Список',
          path: 'entity/:entity/list',
          component: () => import('@/views/admin/Entity-list'),
        },
        {
          name: 'Профиль',
          path: 'profile/main',
          component: () => import('@/views/admin/User-page'),
          props: {
            tab: 0,
            profile: true
          }
        },
        {
          name: 'Профиль',
          path: 'profile/password',
          component: () => import('@/views/admin/User-page'),
          props: {
            tab: 1,
            profile: true
          }
        },
        {
          name: 'Справочники',
          path: 'dictionary/list',
          component: () => import('@/views/admin/Dictionary'),
        },
        {
          name: 'Настройка доступа',
          path: 'access/list',
          component: () => import('@/views/admin/Access-list'),
        },
        {
          name: 'Настройки',
          path: 'setting/list',
          component: () => import('@/views/admin/Setting-list'),
        },
        {
          name: 'Документы',
          path: 'document/list',
          component: () => import('@/views/admin/Document-list'),
        },
        {
          name: 'Пользователь - просмотр',
          path: 'user/view',
          component: () => import('@/views/admin/User-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Пользователь - просмотр',
          path: 'user/create',
          component: () => import('@/views/admin/User-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Клиент - создание',
          path: 'client/create',
          component: () => import('@/views/admin/Client-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Клиент - просмотр',
          path: 'client/view',
          component: () => import('@/views/admin/Client-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Клиент - изменение',
          path: 'client/change',
          component: () => import('@/views/admin/Client-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        // table
        {
          name: 'Создание таблицы',
          path: 'table/create',
          component: () => import('@/views/admin/Table'),
          props: {
            create: true,
          },
        },
        {
          name: 'Изменение таблицы',
          path: 'table/change',
          component: () => import('@/views/admin/Table'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        {
          name: 'Просмотр таблицы',
          path: 'table/view',
          component: () => import('@/views/admin/Table'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        // fiscal
        {
          name: 'Создание операции',
          path: 'fiscal/create',
          component: () => import('@/views/admin/Fiscal-page'),
          props: {
            create: true,
          },
        },
        {
          name: 'Список операций',
          path: 'fiscal/list',
          component: () => import('@/views/admin/Fiscal-list'),
          props: {
            create: true,
          },
        },
        {
          name: 'Просмотр операции',
          path: 'fiscal/view',
          component: () => import('@/views/admin/components/Fiscal-view'),
          props: {
            view: true,
          },
        },
        // payment
        {
          name: 'Создание платежа',
          path: 'payment/create',
          component: () => import('@/views/admin/Payment-page'),
          props: {
            create: true,
          },
        },
        {
          name: 'Просмотр платежа',
          path: 'payment/view',
          component: () => import('@/views/admin/Payment-page'),
          props: {
            view: true,
          },
        },
        {
          name: 'Просмотр платежа (архивный)',
          path: 'payment/archive/view',
          component: () => import('@/views/admin/PaymentArchive-page'),
          props: {
            view: true,
          },
        },
        {
          name: 'Список платежей',
          path: 'payment/list',
          component: () => import('@/views/admin/Payment-list'),
          props: {
            create: true,
          },
        },
        // Entity
        {
          name: 'Создание записи',
          path: 'entity/:entity/create',
          component: () => import('@/views/admin/Entity'),
          props: {
            create: true,
          },
        },
        {
          name: 'Изменение записи',
          path: 'entity/:entity/change',
          component: () => import('@/views/admin/Entity'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        {
          name: 'Просмотр записи',
          path: 'entity/:entity/view',
          component: () => import('@/views/admin/Entity'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Список логов',
          path: 'log/list/',
          component: () => import('@/views/admin/Log-list'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },

        // PLACES
        {
          name: 'Список мест обслуживания',
          path: 'place/list',
          component: () => import('@/views/admin/Place-list'),
        },
        {
          name: 'Место обслуживания - создание',
          path: 'place/create',
          component: () => import('@/views/admin/Place-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Место обслуживания - просмотр',
          path: 'place/view',
          component: () => import('@/views/admin/Place-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Место обслуживания - изменение',
          path: 'place/change',
          component: () => import('@/views/admin/Place-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },

        // OPERATORS
        {
          name: 'Список операторов',
          path: 'operator/list',
          component: () => import('@/views/admin/Operator-list'),
        },
        {
          name: 'Оператор - создание',
          path: 'operator/create',
          component: () => import('@/views/admin/Operator-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Оператор - просмотр',
          path: 'operator/view',
          component: () => import('@/views/admin/Operator-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Оператор - изменение',
          path: 'operator/change',
          component: () => import('@/views/admin/Operator-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },

        // RECIPIENTS
        {
          name: 'Список получателей',
          path: 'recipient/list',
          component: () => import('@/views/admin/Recipient-list'),
        },
        {
          name: 'Получатель - создание',
          path: 'recipient/create',
          component: () => import('@/views/admin/Recipient-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Получатель и услуги - создание',
          path: 'service/create',
          component: () => import('@/views/admin/Recipient-page'),
          props: {
            create: true,
            change: false,
            view: false,
            service: true,
          },
        },
        {
          name: 'Получатель - просмотр',
          path: 'recipient/view',
          component: () => import('@/views/admin/Recipient-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Получатель - изменение',
          path: 'recipient/change',
          component: () => import('@/views/admin/Recipient-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
          // ROLES
        {
          name: 'Список ролей',
          path: 'role/list',
          component: () => import('@/views/admin/Role-list'),
        },
        {
          name: 'Роль',
          path: 'role/create',
          component: () => import('@/views/admin/Role-page'),
        },
        {
          name: 'Роль',
          path: 'role/change',
          component: () => import('@/views/admin/Role-page'),
        },
        // ITEMS
        {
          name: 'Список товаров и услуг',
          path: 'item/list',
          component: () => import('@/views/admin/Item-list'),
        },
        {
          name: 'Товар - создание',
          path: 'item/create',
          component: () => import('@/views/admin/Item-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Товар - просмотр',
          path: 'item/view',
          component: () => import('@/views/admin/Item-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Товар - изменение',
          path: 'item/change',
          component: () => import('@/views/admin/Item-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },

        // ORDERS
        {
          name: 'Заказы',
          path: 'order/list',
          component: () => import('@/views/admin/Order-list'),
        },
        {
          name: 'Заказ - создание',
          path: 'order/create',
          component: () => import('@/views/admin/Services'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Заказ - просмотр',
          path: 'order/view',
          component: () => import('@/views/admin/Order-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Заказ - изменение',
          path: 'order/change',
          component: () => import('@/views/admin/Order-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        // DEVICES
        {
          name: 'Каталог устройств',
          path: 'device/list',
          component: () => import('@/views/admin/Device-list'),
        },
        {
          name: 'Устройство - создание',
          path: 'device/create',
          component: () => import('@/views/admin/Device-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Устройство - просмотр',
          path: 'device/view',
          component: () => import('@/views/admin/Device-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Устройство - изменение',
          path: 'device/change',
          component: () => import('@/views/admin/Device-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        {
          name: 'Список участников',
          path: 'member/list',
          component: () => import('@/views/admin/Member-list'),
        },
        {
          name: 'Список оборудования',
          path: 'kkt/list',
          component: () => import('@/views/admin/Kkt-list'),
        },
        {
          name: 'Список оборудования',
          path: 'kkt/create',
          component: () => import('@/views/admin/Kkt-page'),
        },
        {
          name: 'Список оборудования',
          path: 'kkt/view',
          component: () => import('@/views/admin/Kkt-page'),
        },
        // EQUIPMENT
        {
          name: 'Список оборудования',
          path: 'equipment/list',
          component: () => import('@/views/admin/Equipment-list'),
        },
        {
          name: 'Оборудование - создание',
          path: 'equipment/create',
          component: () => import('@/views/admin/Equipment-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Устройство - просмотр',
          path: 'equipment/view',
          component: () => import('@/views/admin/Equipment-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Устройство - изменение',
          path: 'equipment/change',
          component: () => import('@/views/admin/Equipment-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        {
          name: 'Смена пароля',
          path: 'password-change',
          component: () => import('@/views/admin/Password-change-page'),
        },
        // POINT
        {
          name: 'Список Point',
          path: 'point/list',
          component: () => import('@/views/admin/Point-list'),
        },
        {
          name: 'Point - создание',
          path: 'point/create',
          component: () => import('@/views/admin/Point-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Point - просмотр',
          path: 'point/view',
          component: () => import('@/views/admin/Point-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Point - изменение',
          path: 'point/change',
          component: () => import('@/views/admin/Point-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        {
          name: 'Конфигурации',
          path: 'configuration/list',
          component: () => import('@/views/admin/Configuration-list'),
        },
        {
          name: 'Конфигурации - создание',
          path: 'configuration/create',
          component: () => import('@/views/admin/Configuration-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Конфигурации - просмотр',
          path: 'configuration/view',
          component: () => import('@/views/admin/Configuration-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Конфигурации - изменение',
          path: 'configuration/change',
          component: () => import('@/views/admin/Configuration-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        {
          name: 'Список',
          path: ':entity/list',
          component: () => import('@/views/admin/Universal-list'),
        },
        {
          name: 'Cоздание',
          path: ':entity/create',
          component: () => import('@/views/admin/Universal-page'),
        },
        {
          name: 'Продукт - просмотр',
          path: ':entity/view',
          component: () => import('@/views/admin/Universal-page'),
        },

      ],
    },
    {
      path: '/common',
      component: () => import('@/views/common/Index'),
      children: [
        // Dashboard
        {
          name: 'Common',
          path: 'dashboard',
          component: () => import('@/views/common/Main'),
        },
        {
          name: 'Products',
          path: 'products',
          component: () => import('@/views/common/Products'),
        },
        {
          name: 'Services',
          path: 'services',
          component: () => import('@/views/common/Services'),
        },
        {
          name: 'Профиль',
          path: 'profile',
          component: () => import('@/views/admin/User-page'),
        },
        {
          name: 'Список платежей',
          path: 'payment/list',
          component: () => import('@/views/common/Payment-list'),
          props: {
            create: true,
          },
        },
        {
          name: 'Список заказов',
          path: 'order/list',
          component: () => import('@/views/common/Order-list'),
          props: {
            create: true,
          },
        },
        {
          path: "accountparticipant/edit/:role",
          component: () => import("@/views/loyalty/components/account_participant/AccountParticipantEdit"),
        },
        {
          path: "userprofile/edit/:role",
          component: () => import("@/views/loyalty/components/user_profile/UserProfileEdit"),
        },
      ],
    },
    {
      path: '/client',
      component: () => import('@/views/client/Index'),
      children: [
        ...router_loyalty, // for loyalty
        ...router_reminder_client, // for reminder
        // OPERATORS
        {
          name: 'Список операторов',
          path: 'operator/list',
          component: () => import('@/views/client/Operator-list'),
        },
        {
          name: 'Оператор - создание',
          path: 'operator/create',
          component: () => import('@/views/client/Operator-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Оператор - просмотр',
          path: 'operator/view',
          component: () => import('@/views/client/Operator-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Оператор - изменение',
          path: 'operator/change',
          component: () => import('@/views/admin/Operator-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        // fiscal
        {
          name: 'Создание операции',
          path: 'fiscal/create',
          component: () => import('@/views/client/Fiscal-page'),
          props: {
            create: true,
          },
        },
        {
          name: 'Список операций',
          path: 'fiscal/list',
          component: () => import('@/views/client/Fiscal-list'),
          props: {
            create: true,
          },
        },
        // payment
        {
          name: 'Создание платежа',
          path: 'payment/create',
          component: () => import('@/views/client/Payment-page'),
          props: {
            create: true,
          },
        },
        {
          name: 'Просмотр платежа',
          path: 'payment/view',
          component: () => import('@/views/client/Payment-page'),
          props: {
            view: true,
          },
        },
        {
          name: 'Список платежей',
          path: 'payment/list',
          component: () => import('@/views/client/Payment-list'),
          props: {
            create: true,
          },
        },
        // DEVICES
        {
          name: 'Каталог устройств',
          path: 'device/list',
          component: () => import('@/views/client/Device-list'),
        },
        {
          name: 'Список участников',
          path: 'member/list',
          component: () => import('@/views/client/Member-list'),
          props: {
            create: true,
          },
        },
        {
          name: 'Устройство - создание',
          path: 'device/create',
          component: () => import('@/views/client/Device-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Устройство - просмотр',
          path: 'device/view',
          component: () => import('@/views/client/Device-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Устройство - изменение',
          path: 'device/change',
          component: () => import('@/views/client/Device-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },

        {
          name: 'Профиль',
          path: 'profile/main',
          component: () => import('@/views/client/User-page'),
          props: {
            tab: 0,
            profile: true
          }
        },
        {
          name: 'Профиль',
          path: 'profile/password',
          component: () => import('@/views/client/User-page'),
          props: {
            tab: 1,
            profile: true
          }
        },
        // PLACES
        {
          name: 'Список мест обслуживания client',
          path: 'place/list',
          component: () => import('@/views/client/Place-list'),
        },
        {
          name: 'Место обслуживания - создание client',
          path: 'place/create',
          component: () => import('@/views/client/Place-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Место обслуживания - просмотр client',
          path: 'place/view',
          component: () => import('@/views/client/Place-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Место обслуживания - изменение client',
          path: 'place/change',
          component: () => import('@/views/client/Place-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
      // ROLES
      {
        name: 'Список ролей',
        path: 'role/list',
        component: () => import('@/views/client/Role-list'),
      },
      {
        name: 'Роль',
        path: 'role/create',
        component: () => import('@/views/client/Role-page'),
      },
      {
        name: 'Роль',
        path: 'role/change',
        component: () => import('@/views/client/Role-page'),
      },
       // Users
       {
        name: 'Список user',
        path: 'user/list',
        component: () => import('@/views/client/User-list'),
      },
      {
        name: 'user',
        path: 'user/create',
        component: () => import('@/views/client/User-page'),
      },
      {
        name: 'user',
        path: 'user/change',
        component: () => import('@/views/client/User-page'),
      },
      {
        name: 'user',
        path: 'user/view',
        component: () => import('@/views/client/User-page'),
      },
        // EQUIPMENT
        {
          name: 'Список оборудования - client',
          path: 'equipment/list',
          component: () => import('@/views/client/Equipment-list'),
        },
        {
          name: 'Оборудование - создание client',
          path: 'equipment/create',
          component: () => import('@/views/client/Equipment-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Устройство - просмотр client',
          path: 'equipment/view',
          component: () => import('@/views/client/Equipment-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Устройство - изменение client',
          path: 'equipment/change',
          component: () => import('@/views/client/Equipment-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },

        {
          name: 'Список Point',
          path: 'point/list',
          component: () => import('@/views/client/Point-list'),
        },
        {
          name: 'Point - создание',
          path: 'point/create',
          component: () => import('@/views/client/Point-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Point - просмотр',
          path: 'point/view',
          component: () => import('@/views/client/Point-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Point - изменение',
          path: 'point/change',
          component: () => import('@/views/client/Point-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },

        // RECIPIENTS
        {
          name: 'Список получателей',
          path: 'recipient/list',
          component: () => import('@/views/client/Recipient-list'),
        },
        {
          name: 'Получатель - создание',
          path: 'recipient/create',
          component: () => import('@/views/client/Recipient-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Получатель и услуги - создание',
          path: 'service/create',
          component: () => import('@/views/client/Recipient-page'),
          props: {
            create: true,
            change: false,
            view: false,
            service: true,
          },
        },
        {
          name: 'Получатель - просмотр',
          path: 'recipient/view',
          component: () => import('@/views/client/Recipient-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Получатель - изменение',
          path: 'recipient/change',
          component: () => import('@/views/client/Recipient-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },

        // ITEMS
        {
          name: 'Список товаров и услуг',
          path: 'item/list',
          component: () => import('@/views/client/Item-list'),
        },
        {
          name: 'Товар - создание',
          path: 'item/create',
          component: () => import('@/views/client/Item-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Товар - просмотр',
          path: 'item/view',
          component: () => import('@/views/client/Item-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Товар - изменение',
          path: 'item/change',
          component: () => import('@/views/client/Item-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },

        // ORDERS
        {
          name: 'Заказы',
          path: 'order/list',
          component: () => import('@/views/client/Order-list'),
        },
        {
          name: 'Заказ - создание',
          path: 'order/create',
          component: () => import('@/views/client/Services'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Заказ - просмотр',
          path: 'order/view',
          component: () => import('@/views/client/Order-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Заказ - изменение',
          path: 'order/change',
          component: () => import('@/views/client/Order-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },

        {
          name: 'Конфигурации',
          path: 'configuration/list',
          component: () => import('@/views/client/Configuration-list'),
        },
        {
          name: 'Конфигурации - создание',
          path: 'configuration/create',
          component: () => import('@/views/client/Configuration-page'),
          props: {
            create: true,
            change: false,
            view: false,
          },
        },
        {
          name: 'Конфигурации - просмотр',
          path: 'configuration/view',
          component: () => import('@/views/client/Configuration-page'),
          props: {
            create: false,
            change: false,
            view: true,
          },
        },
        {
          name: 'Конфигурации - изменение',
          path: 'configuration/change',
          component: () => import('@/views/client/Configuration-page'),
          props: {
            create: false,
            change: true,
            view: false,
          },
        },
        {
          name: 'Список оборудования',
          path: 'kkt/list',
          component: () => import('@/views/client/Kkt-list'),
        },
        {
          name: 'Список оборудования',
          path: 'kkt/create',
          component: () => import('@/views/client/Kkt-page'),
        },
        {
          name: 'Список оборудования',
          path: 'kkt/view',
          component: () => import('@/views/client/Kkt-page'),
        },
        {
          name: 'Список',
          path: ':entity/list',
          component: () => import('@/views/client/Universal-list'),
        },
        {
          name: 'Cоздание',
          path: ':entity/create',
          component: () => import('@/views/client/Universal-page'),
        },
        {
          name: 'Продукт - просмотр',
          path: ':entity/view',
          component: () => import('@/views/client/Universal-page'),
        },
        {
          name: 'summary',
          path: 'dashboard',
          component: () => import('@/views/client/Summary-page'),
        },
      ],
    },
    {
      path: '/loyalty',
      component: MainLoyalty,
      children: [
        ...routes_loyalty_auth, // for loyalty
      ],
    },
    ...routes_loyalty_user, // for loyalty
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
})
